export default __webpack_public_path__ + "assets/icons/icon-location.fe1bd1f306f37fd1072443ff552d528d.svg";